// extracted by mini-css-extract-plugin
export var cancelButton = "_pm-5";
export var content = "_pm-3";
export var createButton = "_pm-6";
export var drawerContainer = "_pm-0";
export var footer = "_pm-2";
export var header = "_pm-1";
export var orderFormColumn = "_pm-4";